export default __webpack_public_path__ + "static/media/dish_logo_1000.701d09dc.png";